import { Module } from 'vuex';
import { GoToCampaignInterface } from '@/types/goToCampaignInterface';
import GoToCampaignService from '@/services/management/go-to-campaign.service';

const getDefaultState = () => {
  return {
    enabled: false,
    budget_limit: 0,
    budget_spent: 0,
    hotels: [] as any,
    hotelsLoading: false,
  };
};

const goToCampaignStore: Module<any, any> = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state: any) {
      const s: any = getDefaultState();
      Object.keys(s).forEach(key => {
        state[key] = s[key];
      });
    },
    setGoToCampaign(state, payload: GoToCampaignInterface) {
      const s: any = getDefaultState();
      Object.keys(s).forEach(key => {
        if (key === 'budget_limit' && !payload.budget_limit) {
          state[key] = '0';
          return;
        }
        state[key] = (payload as any)[key];
      });
    },
    setActivationStatus(state, payload: boolean) {
      state.enabled = payload;
    },
    hotelsLoading(state, payload: boolean) {
      state.hotelsLoading = payload;
    },
  },
  actions: {
    triggerGoToCampaignActivation({ commit }, data: any): any {
      return GoToCampaignService.triggerGoToCampaignActivation(data).then((res: any) => {
        if (res && res.data) {
          commit('setActivationStatus', res.data.enabled);
        }
        return res;
      });
    },
    updateBudgetSettings({ commit }, data: any): any {
      return GoToCampaignService.updateBudgetSettings(data).then(res => {
        commit('setGoToCampaign', res.data);
        return res;
      });
    },
    getGoToCampaignBookingsPdf(): any {
      return GoToCampaignService.getGoToCampaignBookingsPdf().then(res => {
        return res;
      });
    },
    getGoToCampaign({ commit }): any {
      commit('hotelsLoading', true);
      return GoToCampaignService.getGoToCampaign()
        .then(res => {
          commit('setGoToCampaign', res.data);
          return res;
        })
        .finally(() => {
          commit('hotelsLoading', false);
        });
    },
  },
};

export default goToCampaignStore;
